// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbe_a bhe_g"};